var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 450 400",
    width: "450pt",
    height: "400pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_MMo2qAvgXo2iG7dvYQVdQz6kt6Vv7Ffu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 400
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_MMo2qAvgXo2iG7dvYQVdQz6kt6Vv7Ffu)"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 193.896 18.1 L 4.834 346.069 C -1.602 357.193 -1.612 370.913 4.808 382.047 C 11.228 393.18 23.099 400.031 35.939 400.011 L 414.061 400.011 C 426.901 400.031 438.772 393.18 445.192 382.047 C 451.612 370.913 451.602 357.193 445.166 346.069 L 256.104 17.725 C 249.598 6.668 237.708 -0.087 224.892 -0.01 C 212.076 0.067 200.269 6.966 193.896 18.1 Z ",
    fill: "rgb(11,104,244)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 224.076 139.12 L 226.014 139.12 C 237.862 139.12 247.48 148.74 247.48 160.589 L 247.48 259.591 C 247.48 271.44 237.862 281.06 226.014 281.06 L 224.076 281.06 C 212.228 281.06 202.61 271.44 202.61 259.591 L 202.61 160.589 C 202.61 148.74 212.228 139.12 224.076 139.12 Z",
    style: {
      stroke: "none",
      fill: "#DFE8F4",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 224.076 301.88 L 226.014 301.88 C 237.862 301.88 247.48 311.501 247.48 323.351 L 247.48 325.349 C 247.48 337.199 237.862 346.82 226.014 346.82 L 224.076 346.82 C 212.228 346.82 202.61 337.199 202.61 325.349 L 202.61 323.351 C 202.61 311.501 212.228 301.88 224.076 301.88 Z",
    style: {
      stroke: "none",
      fill: "#DFE8F4",
      strokeMiterlimit: 10
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0c207cf4ccdd573d18fce1cbe09a903c.svg";
export { ForwardRef as ReactComponent };